import './FormLayout.css'

function FormSection({ label, actions, children }) {
    return (
        <div className="fl-section">
            {label && (
                <div className="fl-section-header">
                    <span className="fl-section-label">{label}</span>
                    {actions}
                </div>
            )}
            <div className="fl-section-body">
                {children}
            </div>
        </div>
    )
}

export default FormSection
